import { render } from "./CompanyProfile.vue?vue&type=template&id=e38f42e4&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"

import "./CompanyProfile.vue?vue&type=style&index=0&id=e38f42e4&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38f42e4"]])

export default __exports__